import type { DropdownDirection } from "@/components/ui/dropdowns/OpticksDropdown.types";
import { useEffect, useRef, useState } from "react";

interface Props {
  open: boolean;
  initialDirection?: DropdownDirection;
  menuHeight?: string;
}

const useDropdownDirection = ({
  open,
  initialDirection = "down",
  menuHeight = "0px",
}: Props) => {
  const [direction, setDirection] = useState<DropdownDirection>(
    initialDirection || "down"
  );
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Only auto-adjust vertical directions; left/right are fixed
    if (
      !open ||
      !containerRef.current ||
      initialDirection === "left" ||
      initialDirection === "right"
    )
      return;

    // Ensure DOM is rendered
    const timer = setTimeout(() => {
      const container = containerRef.current;
      if (!container) return;

      const rect = container.getBoundingClientRect();
      const menuPx = parseFloat(menuHeight) || 0;

      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      if (initialDirection === "up") {
        setDirection(spaceAbove < menuPx ? "down" : "up");
      } else {
        setDirection(
          spaceBelow < menuPx && spaceAbove > spaceBelow ? "up" : "down"
        );
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [open, menuHeight, initialDirection]);

  return {
    direction,
    containerRef,
  };
};

export default useDropdownDirection;
